import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteFeaturedLinkComponent} from './website-featured-link.component'
import {SharedModule} from '../shared/shared.module'

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [WebsiteFeaturedLinkComponent],
  exports: [
    WebsiteFeaturedLinkComponent
  ]
})
export class WebsiteFeaturedLinkModule {
}
